import {
  Button,
  makeStyles,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Box,
  Typography,
  Grid,
  TextField,
  Paper,
} from "@material-ui/core";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import CustomSelect from "../../../common-components/CustomSelect";
import CustomTextField from "../../../common-components/CustomTextField";
import Versions from "./Versions";
import DefaultHours from "./DefaultHours";
import UserManagement from "./UserManagement";
import OtTypes from "./OtTypes";

const useStyles = makeStyles((theme) => ({
  componentPaper: {
    borderRadius: "12px",
    padding: "20px",
    display: "none",
  },
  legendHeader: {
    color: "#0070D2",
    fontWeight: 600,
    fontSize: "14px",
  },
  formGrid: {
    marginBottom: "12px",
  },
  fieldTitle: {
    fontWeight: 600,
    marginBottom: theme.spacing(0.25),
    fontSize: "13px",
  },
  cancelBtn: {
    fontSize: "12px",
    padding: "3px 8px !important",
    textTransform: "none",
    border: "0.5px solid #0176D3",
    color: "#0176D3",
  },
  createBtn: {
    fontSize: "12px",
    padding: "4px 8px !important",
    textTransform: "none",
    background: "#0176D3",
    margin: "20px",
  },
  actionBtns: {
    margin: "16px 0 8px 0",
  },
  popupHeader: {
    marginTop: "-20px",
    marginLeft: "-24px",
    marginRight: "-24px",
    background: "#4b5558",
  },
  closeIconAdd: {
    display: "inline-block",
    color: "black",
    background: "#ffff",
    width: "18px",
    height: "18px",
    borderRadius: "50%",
    cursor: "pointer",
    textAlign: "center",
    position: "absolute",
    top: "5px",
    right: "8px",
    fontSize: "13px",
    fontWeight: 600,
  },
  addColumnTitle: {
    height: "28px",
    textAlign: "center",
    marginBottom: "11px",
    fontWeight: 600,
    paddingTop: "5px",
    color: "#ffff",
  },
  addDialog: {
    width: "350px",
    height: "auto",
    position: "relative",
  },
  popupBtnsAdd: {
    textAlign: "center",
    marginTop: "24px",
  },
  cancelBtn: {
    fontSize: "12px",
    padding: "3px 8px !important",
    textTransform: "none",
    border: "0.5px solid #0176D3",
    color: "#0176D3",
  },
  saveBtn: {
    fontSize: "12px",
    fontWeight: "600",
    padding: "4px 8px !important",
    textTransform: "none",
    border: "1px solid #3599d1",
    color: "#ffff",
    backgroundColor: "#0176d3",
    marginRight: "8px",
  },
}));

const MainPage = "Main";
const VersionPage = "Versions";
const DefaultHoursPage = "Default Hours";
const UserManagementPage = "User Management";
const OTTypesPage = "OT Types";

export default function FinancialManagement({ page }) {
  const classes = useStyles();

  const [selectedPage, setSelectedPage] = useState(DefaultHoursPage);
  const [automaticChangeVersion, setAutomaticVersion] = useState("Yes");
  const [timeforVersion, setTimeforVersion] = useState("");
  const [emailIds, setEmailIds] = useState("");
  const [frequency, setFrequency] = useState("");

  useEffect(() => {
    const childSelected = page.children.filter((val) => val.isSelected);
    if (childSelected.length > 0) {
      setSelectedPage(childSelected[0].page);
    } //else setSelectedPage(MainPage);
  }, [page]);

  const Main = () => {
    return (
      <Paper className={classes.componentPaper} elevation={0}>
        <Grid container spacing={2}>
          <Grid lg={4} className={classes.formGrid}>
            <div className={classes.fieldTitle}>Automatic Change Version</div>
            <CustomSelect
              selectedValue={automaticChangeVersion}
              onChangeItem={(e) => setAutomaticVersion(e.target.value)}
              labelVal=""
              id="selectVersion"
              items={[
                { id: "Yes", text: "Yes" },
                { id: "No", text: "No" },
              ]}
              width="250px"
            />
          </Grid>
          {automaticChangeVersion === "Yes" && (
            <Grid lg={12} className={classes.formGrid}>
              <div className={classes.fieldTitle}>Time For Version Change </div>
              <CustomTextField
                selectedValue={timeforVersion}
                onChangeItem={(e) => setTimeforVersion(e.target.value)}
                id="timeForChange"
                itemWidth="250px"
              />
            </Grid>
          )}
          {automaticChangeVersion === "No" && (
            <Grid lg={12} className={classes.formGrid}>
              <div className={classes.fieldTitle}>
                Email Ids for Version Change Reminder
              </div>
              <CustomTextField
                selectedValue={emailIds}
                onChangeItem={(e) => setEmailIds(e.target.value)}
                id="emailIds"
                itemWidth="250px"
              />
            </Grid>
          )}
          {automaticChangeVersion === "No" && (
            <Grid lg={12} className={classes.formGrid}>
              <div className={classes.fieldTitle}>
                Frequency on email reminder (hours){" "}
              </div>
              <CustomTextField
                selectedValue={frequency}
                onChangeItem={(e) => setFrequency(e.target.value)}
                id="frequency"
                itemWidth="250px"
              />
            </Grid>
          )}
        </Grid>
        <div className={classes.actionBtns}>
          <Button
            size="small"
            color="primary"
            variant="contained"
            disableElevation
            className={classes.createBtn}
            onClick={() => {}}
          >
            Save Details
          </Button>
          <Button
            variant="outlined"
            className={classes.cancelBtn}
            color="primary"
            onClick={() => {}}
          >
            Cancel
          </Button>
        </div>
      </Paper>
    );
  };

  return (
    <>
      {selectedPage === MainPage && <Main />}
      {selectedPage === VersionPage && <Versions />}
      {selectedPage === DefaultHoursPage && <DefaultHours />}
      {selectedPage === UserManagementPage && <UserManagement />}
      {selectedPage === OTTypesPage && <OtTypes />}
    </>
  );
}
